import { useCallback, useEffect, useState } from 'react'

export const useImageSearch = (experiment: string | null) => {
  const [result, setResult] = useState<string | null>(null)

  const fetchImageSearch = useCallback(async () => {
    try {
      const response = await fetch('/en/shop-by-image')
      if (response.status === 200) {
        setResult('b')
      } else {
        setResult('a')
      }
    } catch (error) {
      setResult('a')
    }
  }, [])

  useEffect(() => {
    if (experiment === null && !result) {
      fetchImageSearch()
    }
  }, [result, fetchImageSearch, experiment])

  return result
}
